import React, { Component } from 'react';
import { withRouter, Redirect, Link } from "react-router-dom";
import { Text, View, Image, ScrollView, Platform } from 'react-native';
import Home from '../../native/screens/home';
import ReactGA from 'react-ga';

export class HomeScreen extends Component {
    constructor(props) {
        super(props);
        let postData = (process.browser) ? document.getElementById("postData") : null;
        let footerData = (process.browser) ? document.getElementById("footerData") : null;
        this.state = {
            searchQuery: "",
            locationHash: "",
            homeData: (postData) ? JSON.parse(postData.getAttribute('data')) : ((JSON.stringify(this.props.postData) != '{}') ? this.props.postData : null),
            token: this.props.token,
            footerData: (footerData) ? JSON.parse(footerData.getAttribute('data')) : ((JSON.stringify(this.props.footerData) != '{}') ? this.props.footerData : null),
            scrollTop: false
        }

        if (process.browser) {
            if (postData) {
                postData.parentNode.removeChild(postData);
            }
            if (footerData) {
                footerData.parentNode.removeChild(footerData);
            }
            try {
                ReactGA.pageview('home page');
            }
            catch (error) {
                console.log("GA tracking error =>", error);
            }
        }
    }

    componentDidMount = () => {
        setTimeout(function () {
            window.history.scrollRestoration = "manual";
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            setTimeout(function () {
                document.body.style.overflow = 'initial';
                document.body.style.position = 'initial';
            }, 20);
        }, 20);
        if (window.location.search != this.state.searchQuery) {
            this.setState({
                searchQuery: window.location.search
            })
        }
        if (window.location.hash != this.state.locationHash) {
            this.setState({
                locationHash: window.location.hash
            })
        }
    }

    componentDidUpdate = () => {
        if (window.location.search != this.state.searchQuery) {
            this.setState({
                searchQuery: window.location.search
            })
        }
        if (window.location.hash != this.state.locationHash) {
            this.setState({
                locationHash: window.location.hash
            })
        }
    }

    navigateToScreen = (route, params) => {
        let routeArr = route.split('?')
        const { history } = this.props;
    
        const refreshRegex = /^\/(chaos|business|internet|yesterday|state-of-the-unicorns)\/.+/;
    
        // frontendv2
        if (refreshRegex.test(routeArr[0])) {
            window.location.href = routeArr[0] + (routeArr[1] ? '?' + routeArr[1] : '');
            return;
        }
    
        history.push({
            pathname: routeArr[0],
            search: routeArr[1] ? ('?' + routeArr[1]) : '',
            state: params
        });
    }

    render() {
        const { homeData, scrollTop, footerData, token, searchQuery, locationHash } = this.state;
        return (
            <Home history={this.props.history} searchQuery={searchQuery} locationHash={locationHash} navigateToScreen={this.navigateToScreen} homeData={homeData} token={token} footerData={footerData} scrollTop={scrollTop} />
        )
    }
}

export default withRouter(HomeScreen);